<template>
  <v-container id="delivery-report" fluid tag="section">

    <FilterForm 
      :filter-form="filterForm"
      :ministries="ministries"
      @click-search="search"
    />

    <DeliveryPeriod
        :periodReport="periodReport"
        :loadingReportPeriod="loadingReportPeriod"
    />

    <DeliveryDay
        :dayReport="dayReport"
        :loadingReportByDay="loadingReportByDay"
    />

    <Delivery
      :dataTable="resPeriodReport"
    />

  </v-container>
</template>
<script>

import FilterForm from './components/FilterForm'
// import { formatDate } from '../../../../helpers/utils'
import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'

import RepositoryFactory from "@/repositories/RepositoryFactory";
import DeliveryPeriod from "@/pages/report/delivery-report/components/DeliveryPeriod";
import DeliveryDay from "@/pages/report/delivery-report/components/DeliveryDay";
import Delivery from "@/pages/report/delivery-report/components/Delivery";
const ReportRepository = RepositoryFactory.get('report');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
  components: {
    Delivery,
    DeliveryDay,
    DeliveryPeriod,
    FilterForm,
  },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().startOf('month').format('YYYY-MM-DD'),
          endDate: moment().endOf('month').format('YYYY-MM-DD'),
        },
        ministryIds: []
      },
      periodReport: {

      },
      resPeriodReport: {
        dataDelivery: {
          'Giao thành công': 0,
          'Đang giao hàng': 0,
          'Hoàn': 0
        },
        total: 0
      },
      dayReport: {},
      ministries: [
        {
          id: 'root_100000000',
          name: 'Tất cả',
          children: [],
          level: 0
        },
        {
          id: -1,
          userId: -1,
          name: 'Không người phụ trách',
          level: 0
        }
      ],
      departmentList: [],
      loadingReportPeriod: false,
      loadingReportByDay: false
    };
  },
  async mounted() {
    this.search();
    // this.getListMinistry()
    this.getListMinistryTree()

    this.watchModule = this.$store.watch(
        (state) => {
          return state.module
        },
        async (newVal) => {
          this.filterForm = {
            dateRange: {
              startDate: moment().startOf('month').format('YYYY-MM-DD'),
              endDate: moment().endOf('month').format('YYYY-MM-DD'),
            },
            ministryIds: []
          }
          this.search()
          Bus.$emit('reset-time-delivery-report')
        },
        {
          deep: true
        }
      )
  },
  beforeDestroy () {
    this.watchModule()
  },
  methods: {
    search (filterForm) {
      if(filterForm) {
        this.filterForm = filterForm
      }

      this.getReportByPeriod()
      this.getReportByDays()
      Bus.$emit('delivery-status-report', this.filterForm)
    },

    // Get data báo cáo theo khoảng thời gian ~ denitis
    async getReportByPeriod() {
      const loader = this.$loading.show()
      this.loadingReportPeriod = true;
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        duration: this.filterForm.dateRange.duration,
        // ministryIds: this.filterForm.ministryIds,
        orgIds: this.filterForm.ministryIds.filter(userItem => userItem.hasOwnProperty('orgId')).map(itemMap => itemMap.orgId),
        departmentType: 'retail',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const responsePeriod = await ReportRepository.deliveryReportByPeriod(params)

      loader.hide()
      this.loadingReportPeriod = false

      if (responsePeriod.success) {
        this.resPeriodReport = _.get(responsePeriod, 'data', {})
        const response = _.get(responsePeriod, 'data.dataDelivery', {})
        this.periodReport = {
          series: [],
          labels: [],
          deliveryName: [],
          totalData: 0,
          color: colorChart
        }
        if (response.length < 1) {
          return
        }

        this.periodReport.totalData = responsePeriod.length
        for (const prop in response) {
          let percent = _.get(responsePeriod, 'data.total', 0) ?
              +(response[prop] / _.get(responsePeriod, 'data.total', 0) * 100).toFixed(0)
              : 0;
          this.periodReport.series.push({
            meta: prop + ' :',
            value: percent
          })
          this.periodReport.labels.push(percent.toString() + '%')
        }
        let statusGroup = _.get(responsePeriod, 'data.statusGroup', {})
        for (let [key, value] of Object.entries(statusGroup)) {
          this.periodReport.deliveryName.push({value, key})
        }
      }
    },

    // Get data Báo cáo theo ngày ~ turnover
    async getReportByDays() {
      const loader = this.$loading.show()
      this.loadingReportByDay = true;
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        duration: this.filterForm.dateRange.duration,
        // ministryIds: this.filterForm.ministryIds,
        orgIds: this.filterForm.ministryIds.filter(userItem => userItem.hasOwnProperty('orgId')).map(itemMap => itemMap.orgId),
        departmentType: 'retail',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const responseDay = await ReportRepository.deliveryReportByDays(params)

      loader.hide()
      this.loadingReportByDay = false

      if (responseDay.success) {
        const response = _.get(responseDay, 'data', {})
        this.dayReport = {
          labels: [],
          series: [],
          totalData: 0,
          statusDeliveries: [],
          color: colorChart
        };
        if(response.length < 1 ) {
          return
        }

        this.dayReport.totalData = response.length
        let statusGroup = response.statusGroup
        // let statusGroup = {
        //   11: "Giao thành công",
        //   16: "Đang giao hàng",
        //   27: "Hoàn"
        // }
        const map = [];
        response.orderGroup.forEach( (day, key) => {
          this.dayReport.labels.push(...Object.keys(day))
          Object.keys(day).map((k) => {
            Object.values(statusGroup).map((productValue, index) => {
              if (!map[index]) map[index] = [];
              let tooltip = {
                meta: productValue + ': ' + day[k][productValue] + ', Ngày: ' + Object.keys(day),
                value: ((day[k][productValue]/day[k].total)*100).toFixed(0),
              }
              map[index].push(tooltip);
            });
          })
        });

        for (let [key, value] of Object.entries(statusGroup)) {
          this.dayReport.statusDeliveries.push({value, key})
        }
        this.dayReport.series.push(...map)
      }
    },
    async getListMinistry() {
      // const res = await OrganizationMachineRepository.listMinistryOnly()

      // Danh sách nhánh cấp 3
      const res = await OrganizationMachineRepository.listOrganizationByLevel({
        level: 3
      })

      if (res.success) {
        this.ministries = _.get(res, 'data', [])
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    async getListMinistryTree() {
      this.appLoadingData(true)
      const respond = await OrganizationMachineRepository.listMinistryUserTree({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      this.appLoadingData(false)

      function recursiveRemove (list) {
        return list.map(item => {return {...item}}).filter(item => {
          if ('children' in item) {
            item.children = recursiveRemove(item.children);
          }
          return !item.userId && item.level < 4;
        });
      }

      if (_.get(respond, 'success', false)) {
        let data = _.get(respond, 'data', []).map(item => {
          return {
            ...item,
            level: 0
          }
        });

        this.ministries[0].children = recursiveRemove( data );
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Ko lấy được danh sách user theo bộ phận!',
        })
      }
    },
  }
};
</script>

<style lang="scss">
  #product-group-report {
    ul.description {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 10px 0;
      li {
        margin: 0 5px;
      }
    }
  }
</style>